import React, { Fragment, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Up from "../../images/angle_up.svg";
import Down from "../../images/down.svg";
import back from "../../images/back.svg";
import "../../Pages/Book/createbook.css";
import NewActivity from "../NewActivity";
import Activity from "../Activity";
import dots from "../../images/dots.svg";
import mult_choice from "../../images/mult_choice.png";
import free_response from "../../images/free_response.png";
import fill_in_the_blank from "../../images/fill_in_the_blank.png";
import matching from "../../images/matching.png";
import { filter } from "../../Store/api/activities";
import { setActivitiesLoader } from "../../Store/ui/loaders";
import Cross from "../../assets/images/x.svg";

const images = {
  mult_choice,
  free_response,
  fill_in_the_blank,
  matching,
};
const PickLibRightsidebar = ({
  creatingActivity,
  highlightedSection,
  activities,
  setMousePosition,
  setDraggedChap,
  writingActivity,
  reverseIt,
  reverse,
  mousePosition,
  setCreatingActivity,
  setWritingActivity,
  setReverse,
  setHighlightedIndexes,
  setDraggedOver,
  draggedChap,
  selectedParagraphs,
  dragging,
  setDragging,
  setActivitySetModal,
  draggedOver,
  scrollToParagraph,
  scrollToSection,
  scrollToChapter,
  highlightedParagraph,
  setIsDraggingActivity,
  setDraggedActivityPosition,
  setDraggedActivity,
  showCalendar,
  greyedItemSetter,
  isDraggingActivity,
  draggedActivity,
  draggedActivityPosition,
  hitBottom,
}) => {
  const { book } = useSelector((state) => state.entities);
  const { settings } = useSelector((state) => state.settings.settings);
  const templates = useSelector((state) => state.ui.templates);
  const { user } = useSelector((state) => state.auth);
  const { loaders } = useSelector((state) => state.ui);
  const [spreadActivities, setSpreadActivities] = useState([]);
  const [className, setClassName] = useState("");
  const [newActivities, setNewActvities] = useState([]);
  const [filters, setFilters] = useState({
    own: false,
    author: false,
    all: false,
  });
  const [existingActivities, setExistingActivities] = useState(activities);
  const [draggs, setDraggs] = useState([]);
  let timerId2 = null;
  const dispatch = useDispatch();
  useEffect(() => {
    if (!creatingActivity) {
      timerId2 = setTimeout(() => {
        setClassName("d-none");
      }, 500); // Delay of 0.5 seconds (500 milliseconds)
    } else {
      setClassName("");
    }
    return () => {
      clearTimeout(timerId2); // Clean up the timeout on component unmount or state change
    };
  }, [creatingActivity]);
  useEffect(() => {
    setExistingActivities(activities);
  }, [activities]);
  const spreadActivitiesSetter = (id) => {
    if (spreadActivities.includes(id)) {
      setSpreadActivities(spreadActivities.filter((e) => e !== id));
    } else {
      setSpreadActivities([...spreadActivities, id]);
    }
  };
  const getInnermostElement = (elements) => {
    const element = elements.find(
      (el) =>
        el.classList.contains("chapter_element") ||
        el.classList.contains("section_element") ||
        el.classList.contains("paragraph_element")
    );

    // If an element was found, return it; otherwise, return null
    return element || null;
  };

  const popNewActivity = (index) => {
    let neActs = [...newActivities];
    neActs.splice(index, 1);
    setNewActvities(neActs);
  };

  const dropCard = (event, templat, index) => {
    setDraggs([""]);
    setDraggedOver(null);
    if (draggs.includes(index)) {
      let els = document.elementsFromPoint(event.clientX, event.clientY);

      const element = getInnermostElement(els);

      if (element && element.classList.contains("chapter_element_left")) {
        //scroll to chapter
        scrollToChapter(
          element.dataset.id.split(".")[0],
          book.chapters.findIndex(
            (e) => e._id === element.dataset.id.split(".")[0]
          )
        );
      }
      if (element && element.classList.contains("section_element_left")) {
        //scroll to section
        const chapIndex = book.chapters.findIndex(
          (e) => e._id === element.dataset.id.split(".")[0]
        );
        const chapter = book.chapters[chapIndex];
        const secIndex = chapter.sections.findIndex(
          (e) => e._id === element.dataset.id.split(".")[1]
        );
        scrollToSection(secIndex, chapIndex);
      }
      if (element) {
        let elmentType = element.classList.contains("chapter_element")
          ? "chapter"
          : element.classList.contains("section_element")
          ? "section"
          : "paragraph";
        if (elmentType === "paragraph") {
          setHighlightedIndexes([element.dataset.id]);
          setDraggedChap(
            `${element.dataset.id.split(".")[0]}.${
              element.dataset.id.split(".")[1]
            }`
          );
        } else {
          setDraggedOver({
            index: element.dataset.id,
            type: elmentType,
          });
        }
        setWritingActivity(true);
        setNewActvities([
          ...newActivities,
          {
            book: book._id,
            element: {
              index: element.dataset.id,
              type: elmentType,
            },
            title: "",
            description: "",
            score: "",
            isShared: false,
            type: templat.type,
            questions: [
              {
                type: templat.type,
                text: "",
                description: "",
                score: "",
                options:
                  templat.type === "mcqs"
                    ? [
                        { text: "", type: "text", isCorrect: false },
                        { text: "", type: "text", isCorrect: false },
                      ]
                    : [],
              },
            ],
          },
        ]);
      } else {
        setDraggedOver(null);
      }
    }
    setDragging(false);
    setMousePosition({ x: 0, y: 0 });
  };
  const moveCard = (event, index) => {
    if (draggs.includes(index)) {
      let els = document.elementsFromPoint(event.clientX, event.clientY);
      const element = getInnermostElement(els);
      if (element) {
        let elmentType = element.classList.contains("chapter_element")
          ? "chapter"
          : element.classList.contains("section_element")
          ? "section"
          : "paragraph";
        setDraggedOver({
          index: element.dataset.id,
          type: elmentType,
        });
      } else {
        setDraggedOver(null);
      }
    }
  };
  useEffect(() => {
    dispatch(setActivitiesLoader(true));
    if (filters.all) {
      dispatch(
        filter({
          bookId: book._id,
          queryParams: { query: "allauthors" },
          onSuccess: (res) => {
            setExistingActivities([
              ...activities.filter((e) => e.owner._id === user._id),
              ...res.data.data,
            ]);
          },
        })
      );
    } else if (filters.own && !filters.author) {
      setExistingActivities(activities.filter((e) => e.owner._id === user._id));
      dispatch(setActivitiesLoader(false));
    } else if (filters.author && !filters.own) {
      setExistingActivities(activities.filter((e) => e.owner._id !== user._id));
      dispatch(setActivitiesLoader(false));
    } else {
      setExistingActivities(activities);
      dispatch(setActivitiesLoader(false));
    }
  }, [filters]);

  const handleCheckBox = (value) => {
    if (value === "all") {
      setFilters({ own: false, author: false, all: !filters["all"] });
    } else {
      setFilters((old) => {
        return { ...old, [value]: !old[value], all: false };
      });
    }
  };
  return (
    <div
      className={` left_side_bar right_side_bar pick_lib_padding ${
        settings.bookMode ? "d-none" : ""
      }`}
    >
      {" "}
      {/*Creating new activity*/}
      <div
        className={`custom_nav templates_modal_inner  ${
          creatingActivity === undefined
            ? ""
            : !creatingActivity
            ? `animate-down`
            : "animate-up"
        } ${className}`}
        id="templates_wrap"
        style={{
          display: creatingActivity === undefined ? "none" : "",
        }}
      >
        <div className="inner_right">
          <div
            className="collapse_btn top_postion"
            onClick={(e) => {
              e.preventDefault();

              setCreatingActivity(false);
              setWritingActivity(false);
              setDraggedOver(null);
              setHighlightedIndexes([]);
              setReverse(false);
              setNewActvities([]);
            }}
          >
            <img
              src={Down}
              alt=""
              style={{
                filter:
                  "grayscale(100%) sepia(30%) hue-rotate(240deg) brightness(90%) contrast(80%)",
              }}
            />
            <br />
            <a href="#!" className="btn btn-link btn_back">
              collapse
            </a>
          </div>
          <div className="inner-right-wrap">
            {
              <div className="p-sticky-right">
                <div
                  className={`back_all_btn top_postion ${
                    reverse ? "reverse_back" : ""
                  }`}
                >
                  <a
                    href="#!"
                    className="btn btn-link btn_back"
                    onClick={reverseIt}
                  >
                    <img
                      src={back}
                      alt="back"
                      style={{
                        filter:
                          "grayscale(100%) sepia(30%) hue-rotate(240deg) brightness(90%) contrast(80%)",
                      }}
                    />
                  </a>
                </div>
                <ul
                  className="nav nav-tabs nav-justified"
                  id="myTab"
                  role="tablist"
                >
                  <li className="nav-item" role="presentation">
                    <button
                      className="internal nav-link active"
                      id="nav-templates-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#nav-templates"
                      type="button"
                      role="tab"
                      aria-controls="nav-templates"
                      aria-selected="true"
                    >
                      create new activity
                    </button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button
                      className="internal nav-link"
                      id="nav-saved-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#nav-saved"
                      type="button"
                      role="tab"
                      aria-controls="nav-saved"
                      aria-selected="false"
                    >
                      Explore
                    </button>
                  </li>
                </ul>
              </div>
            }

            <div className="right_box_border multi_templates_wrap">
              <div className="tab-content">
                <div
                  className="tab-pane fade show active"
                  id="nav-templates"
                  role="tabpanel"
                  aria-labelledby="nav-templates-tab"
                >
                  {writingActivity ? (
                    <div>
                      {newActivities.map((newActivity, index) => (
                        <NewActivity
                          chap={draggedChap}
                          pop={popNewActivity}
                          draggedOver={draggedOver}
                          paragraphs={selectedParagraphs}
                          activity={newActivity}
                          index={index}
                          key={index}
                        />
                      ))}

                      <div className="right_box_border">
                        <div className="f10 text-center mb-0">
                          Add another{" "}
                          <div
                            className="Multiplechoice_wrap"
                            style={{ display: "inline-flex" }}
                          >
                            <div className="btn-group">
                              <button
                                type="button"
                                className="btn btn-link dropdown-toggle"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                              >
                                multiple-choice
                              </button>
                              <ul className="dropdown-menu">
                                {templates.map((temp, index) => (
                                  <li>
                                    <a
                                      href="#!"
                                      className="dropdown-item cursor"
                                      onClick={(e) => {
                                        e.preventDefault();
                                        setNewActvities([
                                          ...newActivities,
                                          {
                                            book: book._id,
                                            element: draggedOver
                                              ? draggedOver
                                              : {},
                                            name: "",
                                            description: "",
                                            score: "",
                                            type: temp.type,
                                            isShared: false,
                                            paragraphs: selectedParagraphs,
                                            questions: [
                                              {
                                                type: temp.type,
                                                text: "",
                                                description: "",
                                                options:
                                                  temp.type === "mcqs"
                                                    ? ["", ""]
                                                    : [],
                                              },
                                            ],
                                          },
                                        ]);
                                      }}
                                    >
                                      {temp.name}
                                    </a>
                                  </li>
                                ))}
                              </ul>
                            </div>
                          </div>
                          activity to section
                        </div>
                      </div>
                    </div>
                  ) : (
                    <Fragment>
                      {templates.map((templat, index) => (
                        <div key={index}>
                          {dragging && draggs.includes(index) ? (
                            <div
                              className="multi_templates disable_templates"
                              style={{ marginBottom: "30px" }}
                            >
                              <div className="div_three">
                                <div className="div_two">
                                  <div className="div_one">
                                    <div className="content">
                                      <div className="icon_tamplet">
                                        <img
                                          src={dots}
                                          className="img-fluid"
                                          alt="dots"
                                        />
                                      </div>
                                      <h1>{templat.name}</h1>
                                      <img
                                        src={images[templat.image]}
                                        className="img-fluid mt-2"
                                        alt={templat.name}
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          ) : (
                            ""
                          )}
                          <div
                            data-id={"123"}
                            style={{
                              display: "flex",
                              position:
                                dragging && draggs.includes(index)
                                  ? "fixed"
                                  : "relative",
                              zIndex:
                                dragging && draggs.includes(index) ? 2 : 0,
                              left:
                                dragging && draggs.includes(index)
                                  ? `${mousePosition.x - 0.5}%`
                                  : "",
                              top:
                                dragging && draggs.includes(index)
                                  ? `${mousePosition.y - 7}%`
                                  : "",
                              minWidth: "18%",
                              borderRadius: "4px",
                              marginBottom: "30px",
                              // transform:
                              //   dragging && draggs.includes(index)
                              //     ? `rotate(${
                              //         draggs.indexOf(index) * 3
                              //       }deg) translateX(${
                              //         draggs.indexOf(index) * 2
                              //       }px)`
                              //     : ""
                            }}
                            onMouseUp={(event) =>
                              dropCard(event, templat, index)
                            }
                            onMouseMove={(event) => {
                              moveCard(event, index);
                              hitBottom(event);
                            }}
                          >
                            <div
                              className={`multi_templates ${
                                draggs.includes(index) ? "dragging" : ""
                              }`}
                            >
                              <div
                                className={`div_three`}
                                style={{
                                  transform: draggs.includes(index)
                                    ? "none"
                                    : "",
                                }}
                              >
                                <div
                                  className="div_two"
                                  style={{
                                    transform: draggs.includes(index)
                                      ? "none"
                                      : "",
                                  }}
                                >
                                  <div
                                    className="div_one"
                                    style={{
                                      transform: draggs.includes(index)
                                        ? "none"
                                        : "",
                                    }}
                                  >
                                    <div className="content">
                                      <div
                                        className="icon_tamplet"
                                        style={{
                                          height: draggs.includes(index)
                                            ? "144px"
                                            : "",
                                        }}
                                        onMouseDown={(event) => {
                                          event.stopPropagation();
                                          // save original position on mousedown
                                          if (!draggs.includes(index)) {
                                            setDraggs([index]);
                                          } else {
                                            // setDraggs(draggs.filter(e => e !== index))
                                          }
                                          setDragging(true);
                                          event.preventDefault();
                                        }}
                                      >
                                        <img
                                          src={dots}
                                          className="img-fluid"
                                          alt="dots"
                                        />
                                      </div>
                                      <h1>{templat.name}</h1>
                                      {!dragging ? (
                                        <span>
                                          drag to the book to create linked
                                          activity
                                        </span>
                                      ) : (
                                        ""
                                      )}
                                      <img
                                        src={images[templat.image]}
                                        className="img-fluid mt-2"
                                        alt={templat.name}
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </Fragment>
                  )}
                </div>
                <div
                  className="tab-pane fade"
                  id="nav-saved"
                  role="tabpanel"
                  aria-labelledby="nav-saved-tab"
                >
                  {book.activitiesSet !== "original" && (
                    <Fragment>
                      {existingActivities
                        .filter((e) => e.owner !== user._id)
                        .map((activity, index) => (
                          <Fragment>
                            <Activity
                              // clas="drager"
                              // onMouseDown={mouseStart}
                              scroll={scrollToSection}
                              spreadActivitiesSetter={spreadActivitiesSetter}
                              scrollToParagraph={scrollToParagraph}
                              key={index}
                              activity={activity}
                              index={index}
                              highlightedParagraph={highlightedParagraph}
                              setIsDraggingActivity={setIsDraggingActivity}
                              setDraggedActivityPosition={
                                setDraggedActivityPosition
                              }
                              setDraggedActivity={setDraggedActivity}
                              isDraggingActivity={isDraggingActivity}
                              showCalendar={showCalendar}
                              greyedItemSetter={greyedItemSetter}
                              pickLib={"create"}
                            />

                            {isDraggingActivity &&
                              draggedActivity &&
                              draggedActivity._id === activity._id && (
                                <div
                                  className=""
                                  style={{
                                    position: "fixed",
                                    top: `${draggedActivityPosition.top}%`,
                                    left: `${
                                      draggedActivityPosition.left + 0.5
                                    }%`,
                                    zIndex: "9",
                                    width: "5.8%",
                                  }}
                                >
                                  <div className="custom-event assigned-event">
                                    <div className="event-title">
                                      {activity.title}
                                    </div>
                                  </div>
                                </div>
                              )}
                          </Fragment>
                        ))}
                    </Fragment>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          style={{
            height: "100%",
            width: "6px",
            background: "var(--Grey-200, #F0F0EF)",
          }}
          className="side-div"
        ></div>
        <div
          style={{
            height: "100%",
            width: "8px",
            background: "var(--Grey-300, #E6E5E4)",
          }}
          className="side-div"
        ></div>
        <div
          style={{
            height: "100%",
            width: "10px",
            background: "var(--Grey-400, #D2CFCB)",
            borderTopRightRadius: "6px",
          }}
          className="side-div"
        ></div>
      </div>
      {/**/}
      <div style={{ position: "relative" }}>
        {/* <InnerSideHeader highlightedSection={highlightedSection} /> */}
        <div className="activity-header-wrap ">
          <div className="custom_nav w-80">
            {/*  <ul className="nav nav-tabs nav-justified">
              <li className="nav-item">
                <button type="button" className="nav-link active">
                  Assigned
                </button>
              </li>
              <li className="nav-item">
                <button type="button" className="nav-link">
                  Linked to book
                </button>
              </li>
            </ul>
            <div className="chackbox_main">
              <div className="iagree_radio">
                <input
                  type="checkbox"
                  id="own"
                  checked={filters.own}
                  onChange={() => handleCheckBox("own")}
                />
                <label htmlFor="own">My activities </label>
              </div>
              <div className="iagree_radio">
                <input
                  type="checkbox"
                  id="author"
                  checked={filters.author}
                  onChange={() => handleCheckBox("author")}
                />
                <label for="author">Original author</label>
              </div>
              <div className="iagree_radio">
                <input
                  type="checkbox"
                  id="all"
                  checked={filters.all}
                  onChange={() => handleCheckBox("all")}
                />
                <label for="all">All authors </label>
              </div>
            </div> */}
            <div className="custom-sticky-header">
              <div style={{ width: "87%", margin: "0px auto" }}>
                <ul className="nav nav-tabs nav-justified">
                  <li className="nav-item">
                    <button
                      type="button"
                      className="nav-link active"
                      data-bs-toggle="tab"
                      data-bs-target="#assigned"
                      role="tab"
                      aria-controls="assigned"
                      aria-selected="true"
                    >
                      Assigned
                    </button>
                  </li>
                  <li className="nav-item">
                    <button
                      type="button"
                      className="nav-link"
                      data-bs-toggle="tab"
                      data-bs-target="#linked"
                      role="tab"
                      aria-controls="linked"
                      aria-selected="true"
                    >
                      Linked to book
                    </button>
                  </li>
                </ul>
              </div>
              <div className="chackbox_main">
                <div
                  className={`cursor custom_filter ${
                    filters.own ? "active" : ""
                  }`}
                  onClick={() => {
                    if (filters.own) {
                      return;
                    } else {
                      handleCheckBox("own");
                    }
                  }}
                >
                  My activities (
                  {activities.filter((e) => e.owner._id === user._id).length}){" "}
                  {filters.own && (
                    <img
                      width={16}
                      src={Cross}
                      alt=""
                      onClick={(e) => {
                        e.stopPropagation();
                        handleCheckBox("own");
                      }}
                    ></img>
                  )}
                </div>
                <div
                  className={`cursor custom_filter ${
                    filters.author ? "active" : ""
                  }`}
                  onClick={() => {
                    if (filters.author) {
                      return;
                    } else {
                      handleCheckBox("author");
                    }
                  }}
                >
                  Original authors (
                  {activities.filter((e) => e.owner._id !== user._id).length}){" "}
                  {filters.author && (
                    <img
                      width={16}
                      src={Cross}
                      alt=""
                      onClick={(e) => {
                        e.stopPropagation();
                        handleCheckBox("author");
                      }}
                    ></img>
                  )}
                </div>
                <div
                  className={`cursor custom_filter ${
                    filters.all ? "active" : ""
                  }`}
                  onClick={() => {
                    if (filters.all) {
                      return;
                    } else {
                      handleCheckBox("all");
                    }
                  }}
                >
                  All authors
                  {filters.all && (
                    <img
                      width={16}
                      src={Cross}
                      alt=""
                      onClick={(e) => {
                        e.stopPropagation();
                        handleCheckBox("all");
                      }}
                    ></img>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div>
          {!loaders.activitiesLoader ? (
            <Fragment>
              {" "}
              {existingActivities.map((activity, index) => (
                // <Draggable>
                <Fragment>
                  <Activity
                    // clas="drager"
                    // onMouseDown={mouseStart}
                    scroll={scrollToSection}
                    spreadActivitiesSetter={spreadActivitiesSetter}
                    scrollToParagraph={scrollToParagraph}
                    key={index}
                    activity={activity}
                    index={index}
                    highlightedParagraph={highlightedParagraph}
                    setIsDraggingActivity={setIsDraggingActivity}
                    setDraggedActivityPosition={setDraggedActivityPosition}
                    greyedItemSetter={greyedItemSetter}
                    setDraggedActivity={setDraggedActivity}
                    isDraggingActivity={isDraggingActivity}
                    showCalendar={showCalendar}
                    style={{ padding: "0px 10px" }}
                  />
                  {isDraggingActivity &&
                    draggedActivity &&
                    draggedActivity._id === activity._id && (
                      <div
                        className=""
                        style={{
                          position: "fixed",
                          top: `${draggedActivityPosition.top}%`,
                          left: `${draggedActivityPosition.left + 0.5}%`,
                          zIndex: "9",
                          width: "5.8%",
                        }}
                      >
                        <div className="custom-event assigned-event">
                          <div className="event-title">{activity.title}</div>
                        </div>
                      </div>
                    )}
                </Fragment>

                // </Draggable>
              ))}
            </Fragment>
          ) : (
            <Fragment>
              <div>Loading...</div>
            </Fragment>
          )}
          {book.activitiesSet === null && <div style={{ height: "5vh" }}></div>}
        </div>
      </div>
      <div style={{ position: "relative" }}>
        {
          !creatingActivity && !writingActivity ? (
            <button
              type="button"
              className="create_btn left_bottom_btn"
              onClick={(e) => {
                if (
                  book.activitiesSet === null ||
                  book.activitiesSet === "original"
                ) {
                  setActivitySetModal({
                    show: true,
                    choice: "own",
                  });
                } else {
                  setCreatingActivity(true);
                }
              }}
            >
              Create your own activity <img src={Up} alt="up" />
            </button>
          ) : (
            ""
          ) /* writingActivity ? (
          <button
            type="button"
            className="create_btn"
            onClick={(e) => {
              setCreatingActivity(true);
            }}>
            Save and assign activities
          </button>
        ) : (
          ""
        ) */
        }
        {!writingActivity && book.activitiesSet === null && (
          <button
            className={`use_btn ${reverse ? "reverse_use_btn" : ""} ${
              !creatingActivity && "bot-58"
            }`}
            onClick={(e) => {
              setActivitySetModal({
                show: true,
                choice: "original",
              });

              setCreatingActivity(false);
            }}
          >
            Use this book with activities from the author
          </button>
        )}
      </div>
    </div>
  );
};

export default PickLibRightsidebar;
